export default __webpack_public_path__ + "static/media/icon.c23ad512.png";